<template>
  <div>
    <!-- La sección de filtros activos ahora vive en el padre
         (Resultadosclima), fija arriba junto a la leyenda. -->
    <!-- Main Results -->
    <div class="columns main-result-row">
      <div class="column"></div>
      <div class="column is-8">
        <div class="has-text-centered is-size-3">
          <div
            :class="
              `rango${rangos(
                summary.total ? summary.total.CClimad.p : 0,
              )} radius-6 cursor`
            "
            v-tooltip.bottom="{
              content: 'Clic para ver más.',
              classes: 'darkTooltip',
            }"
            v-on:click="
              $emit('open-menu-inter', {
                type: 1,
                group: 'climalab',
                subGroup: null,
                title: 'Clima',
                p: summary.total ? summary.total.CClimad.p : 0,
                color: rangos(
                  summary.total ? summary.total.CClimad.p : 0,
                ),
              })
            "
          >
            <div
              v-if="summary.total"
              class="is-flex is-justify-center clima-main-flex"
              style="align-items: center;"
            >
              <div class="clima-text-block">
                <p class="clima-nombre-line">
                  {{ nameResults() }}
                  <span>
                    {{
                      nombrerangos[
                        rangos(
                          summary.total ? summary.total.CClimad.p : 0,
                        )
                      ]
                    }}
                  </span>
                </p>
                <div class="clima-content-value">
                  <p class="clima-valor-line">
                    {{
                      summary.total
                        ? summary.total.CClimad.p
                        : 0 | number1(1)
                    }}%
                  </p>
                  <direction-indicator
                    v-if="summary.processComp"
                    :w="30"
                    :h="30"
                    :summary="summary"
                    :nombrerangos="nombrerangos"
                    group="CClimad"
                    :rangos="rangos"
                  />
                </div>
              </div>

              <!-- Badge engagement — solo visible en mobile -->
              <div
                v-if="summary.total"
                class="engagement-badge-mobile is-hidden-tablet"
                :class="
                  `rango${rangos(
                    summary.total ? summary.total.engad.p : 0,
                  )}`
                "
                v-on:click.stop="
                  $emit('open-menu-inter', {
                    type: 1,
                    group: 'dimenc',
                    subGroup: 'engad',
                    title: 'Engagement',
                    p: summary.total ? summary.total.engad.p : 0,
                    color: rangos(
                      summary.total ? summary.total.engad.p : 0,
                    ),
                  })
                "
              >
                <span class="engagement-badge-label">Engagement</span>
                <div class="engagement-badge-conntent-value">
                  <span class="engagement-badge-value">
                    {{
                      summary.total
                        ? summary.total.engad.p
                        : 0 | number1(1)
                    }}%
                  </span>
                  <direction-indicator
                    v-if="summary.processComp"
                    :w="16"
                    :h="16"
                    :summary="summary"
                    :nombrerangos="nombrerangos"
                    group="engad"
                    :rangos="rangos"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="is-flex is-justify-center is-size-5"
          v-if="
            infoProcess.participationFilter ||
              infoProcess.totalPartiFilter
          "
        >
          <div class="tags has-addons">
            <span class="tag is-medium">
              Participación: {{ infoProcess.participationFilter }}%
            </span>
            <span class="tag is-medium">
              Encuestados: {{ infoProcess.totalPartiFilter }}
            </span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="header-right-actions">
          <div
            v-if="summary.total"
            v-on:click="
              $emit('open-menu-inter', {
                type: 1,
                group: 'dimenc',
                subGroup: 'engad',
                title: 'Engagement',
                p: summary.total ? summary.total.engad.p : 0,
                color: rangos(
                  summary.total ? summary.total.engad.p : 0,
                ),
              })
            "
            v-tooltip.bottom="{
              content: 'Clic para ver más.',
              classes: 'darkTooltip',
            }"
            class="engagement-circle cursor"
            :class="
              `rango${rangos(
                summary.total ? summary.total.engad.p : 0,
              )}`
            "
          >
            <span class="engagement-label">Engagement</span>
            <div class="engagement-value-row">
              <span class="engagement-value">
                {{
                  summary.total
                    ? summary.total.engad.p
                    : 0 | number1(1)
                }}%
              </span>
              <direction-indicator
                v-if="summary.processComp"
                class="engagement-variation"
                :w="16"
                :h="16"
                :summary="summary"
                :nombrerangos="nombrerangos"
                group="engad"
                :rangos="rangos"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="graphsContent"
      class="columns is-gapless is-multiline"
      style="position: relative"
    >
      <div class="column is-12 is-hidden-mobile">
        <div
          class="has-text-centered is-size-4-desktop is-size-6-tablet"
        >
          <h1>
            Flexibilidad
          </h1>
        </div>
      </div>
      <div class="column is-6">
        <div class="notification bloquex1">
          <div
            class="control cursor"
            v-on:click="
              $emit('open-menu-inter', {
                type: 1,
                group: 'apoyod',
                subGroup: null,
                title: 'Apoyo',
                p: summary.total ? summary.total.apoyod.p : 0,
                color: rangos(
                  summary.total ? summary.total.apoyod.p : 0,
                ),
              })
            "
          >
            <div
              class="tags has-addons"
              style="width: fit-content;"
              v-tooltip.bottom="{
                content: 'Clic para ver más.',
                classes: 'darkTooltip',
              }"
            >
              <span
                class="tag is-medium tagName"
                :class="
                  `rango${rangos(
                    summary.total ? summary.total.apoyod.p : 0,
                  )}`
                "
              >
                Apoyo
              </span>
              <span
                class="tag is-medium tagNumber"
                :class="
                  `rango${rangos(
                    summary.total ? summary.total.apoyod.p : 0,
                  )}`
                "
              >
                {{
                  summary.total
                    ? summary.total.apoyod.p
                    : 0 | number1(1)
                }}%
              </span>
              <span
                class="tag is-medium tagIcon"
                :class="
                  `rango${rangos(
                    summary.total ? summary.total.apoyod.p : 0,
                  )}`
                "
                v-if="summary.processComp"
              >
                <direction-indicator
                  :w="25"
                  :h="25"
                  :summary="summary"
                  :nombrerangos="nombrerangos"
                  group="apoyod"
                  :rangos="rangos"
                />
              </span>
            </div>
          </div>
          <div class="columns">
            <div class="column is-8" v-if="summary">
              <y-graph
                :data="createGraph(['apsd', 'vincd', 'apod'], 'apoyod')"
                :change="change"
              ></y-graph>
            </div>
            <div class="column"></div>
          </div>
        </div>
      </div>
      <div class="column is-6">
        <div class="notification bloquex2">
          <div
            class="control cursor"
            v-on:click="
              $emit('open-menu-inter', {
                type: 1,
                group: 'innovaciond',
                subGroup: null,
                title: 'Innovación',
                p: summary.total ? summary.total.innovaciond.p : 0,
                color: rangos(
                  summary.total ? summary.total.innovaciond.p : 0,
                ),
              })
            "
          >
            <div
              class="tags has-addons is-right"
              style="width: fit-content; margin-left: auto;"
              v-tooltip.bottom="{
                content: 'Clic para ver más.',
                classes: 'darkTooltip',
              }"
            >
              <span
                class="tag is-medium tagName"
                :class="
                  `rango${rangos(
                    summary.total ? summary.total.innovaciond.p : 0,
                  )}`
                "
              >
                Innovación
              </span>
              <span
                class="tag is-medium tagNumber"
                :class="
                  `rango${rangos(
                    summary.total ? summary.total.innovaciond.p : 0,
                  )}`
                "
              >
                {{
                  summary.total
                    ? summary.total.innovaciond.p
                    : 0 | number1(1)
                }}%
              </span>
              <span
                class="tag is-medium tagIcon"
                :class="
                  `rango${rangos(
                    summary.total ? summary.total.innovaciond.p : 0,
                  )}`
                "
                v-if="summary.processComp"
              >
                <direction-indicator
                  :w="25"
                  :h="25"
                  :summary="summary"
                  :nombrerangos="nombrerangos"
                  group="innovaciond"
                  :rangos="rangos"
                />
              </span>
            </div>
          </div>
          <div class="columns">
            <div class="column is-4"></div>
            <div class="column is-8" v-if="summary">
              <y-graph
                :data="
                  createGraph(['autd', 'agid', 'mejd'], 'innovaciond')
                "
                :change="change"
              ></y-graph>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-12">
        <div class="notification has-text-center bloquex5">
          <div class="has-text-centered is-fullwidth">
            <strong>Dimensiones Centrales</strong>
          </div>
          <div v-if="summary">
            <y-graph
              :data="createGraph(['lidd', 'recd', 'compd'], 'dimenc')"
              :change="change"
            ></y-graph>
          </div>
        </div>
      </div>
      <div class="column is-6">
        <div class="notification bloquex3">
          <div
            class="control cursor"
            v-on:click="
              $emit('open-menu-inter', {
                type: 1,
                group: 'calidadd',
                subGroup: null,
                title: 'Calidad',
                p: summary.total ? summary.total.calidadd.p : 0,
                color: rangos(
                  summary.total ? summary.total.calidadd.p : 0,
                ),
              })
            "
          >
            <div
              class="tags has-addons"
              style="width: fit-content;"
              v-tooltip.bottom="{
                content: 'Clic para ver más.',
                classes: 'darkTooltip',
              }"
            >
              <span
                class="tag is-medium tagName"
                :class="
                  `rango${rangos(
                    summary.total ? summary.total.calidadd.p : 0,
                  )}`
                "
              >
                Calidad
              </span>
              <span
                class="tag is-medium tagNumber"
                :class="
                  `rango${rangos(
                    summary.total ? summary.total.calidadd.p : 0,
                  )}`
                "
              >
                {{
                  summary.total
                    ? summary.total.calidadd.p
                    : 0 | number1(1)
                }}%
              </span>
              <span
                class="tag is-medium tagIcon"
                :class="
                  `rango${rangos(
                    summary.total ? summary.total.calidadd.p : 0,
                  )}`
                "
                v-if="summary.processComp"
              >
                <direction-indicator
                  :w="25"
                  :h="25"
                  :summary="summary"
                  :nombrerangos="nombrerangos"
                  group="calidadd"
                  :rangos="rangos"
                />
              </span>
            </div>
          </div>
          <div class="columns">
            <div class="column is-8" v-if="summary">
              <y-graph
                :data="
                  createGraph(['excd', 'cycd', 'segd'], 'calidadd')
                "
                :change="change"
              ></y-graph>
            </div>
            <div class="column is-4"></div>
          </div>
        </div>
      </div>
      <div class="column is-6">
        <div class="notification bloquex4">
          <div
            class="control cursor"
            v-on:click="
              $emit('open-menu-inter', {
                type: 1,
                group: 'metasd',
                subGroup: null,
                title: 'Metas',
                p: summary.total ? summary.total.metasd.p : 0,
                color: rangos(
                  summary.total ? summary.total.metasd.p : 0,
                ),
              })
            "
          >
            <div
              class="tags has-addons is-8 is-right"
              style="width: fit-content; margin-left: auto;"
              v-tooltip.bottom="{
                content: 'Clic para ver más.',
                classes: 'darkTooltip',
              }"
            >
              <span
                class="tag is-medium tagName"
                :class="
                  `rango${rangos(
                    summary.total ? summary.total.metasd.p : 0,
                  )}`
                "
              >
                Metas
              </span>
              <span
                class="tag is-medium tagNumber"
                :class="
                  `rango${rangos(
                    summary.total ? summary.total.metasd.p : 0,
                  )}`
                "
              >
                {{
                  summary.total
                    ? summary.total.metasd.p
                    : 0 | number1(1)
                }}%
              </span>
              <span
                class="tag is-medium tagIcon"
                :class="
                  `rango${rangos(
                    summary.total ? summary.total.metasd.p : 0,
                  )}`
                "
                v-if="summary.processComp"
              >
                <direction-indicator
                  :w="25"
                  :h="25"
                  :summary="summary"
                  :nombrerangos="nombrerangos"
                  group="metasd"
                  :rangos="rangos"
                />
              </span>
            </div>
          </div>
          <div class="columns">
            <div class="column is-4"></div>
            <div class="column is-8" v-if="summary">
              <y-graph
                :data="
                  createGraph(['logrd', 'servd', 'repd'], 'metasd')
                "
                :change="change"
              ></y-graph>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-12 is-hidden-mobile">
        <div
          class="has-text-centered is-size-4-desktop is-size-6-tablet"
        >
          <h1>
            Consistencia
          </h1>
        </div>
      </div>
      <!--    Titles Left and Right   -->
      <div class="column is-12 is-hidden-mobile">
        <div
          class="has-text-left is-size-5-desktop is-size-6-tablet titleLeft"
        >
          <h1>
            Foco Interno
          </h1>
        </div>
      </div>
      <div class="column is-12 is-hidden-mobile">
        <div
          class="has-text-left is-size-5-desktop is-size-6-tablet titleRight"
        >
          <h1>
            Foco Externo
          </h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CLIMA_COLORS } from "../../climaColors";
import json from "../../interpretaciones.json";
import yGraph from "../../../dashboard/GraphApexChart.vue";
import directionIndicator from "../directionIndicator.vue";

export default {
  name: "Prioritization",
  components: {
    yGraph,
    directionIndicator,
  },
  props: {
    summary: {
      type: Object,
      required: true,
    },
    namevars: {
      type: Object,
      required: true,
    },
    nombrerangos: {
      type: Object,
      required: true,
    },
    rangos: {
      type: Function,
      required: true,
    },
    infoProcess: {
      type: Object,
      required: true,
    },
    change: {
      type: Number,
      required: true,
    },
    nameResults: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      calificaciones: json,
    };
  },
  methods: {
    createGraph(labels, group) {
      if (this.summary && labels) {
        const colors = [
          "#a5a5a5",
          CLIMA_COLORS[1],
          CLIMA_COLORS[2],
          CLIMA_COLORS[3],
          CLIMA_COLORS[4],
          CLIMA_COLORS[5],
          CLIMA_COLORS[6],
        ];
        let dataSummary = this.summary;
        labels = labels.filter((x) =>
          Object.keys(dataSummary.total).includes(x),
        );
        let graph = {
          series: [
            {
              name: "Actual",
              data: [
                {
                  x: "Datos",
                  y: 12,
                  goals: [
                    {
                      name: "Anterior",
                      value: 14,
                      strokeWidth: 2,
                      strokeDashArray: 2,
                      strokeColor: "#775DD0",
                    },
                  ],
                },
              ],
            },
          ],
          options: {
            chart: {
              width: "100%",
              height: "100%",
              redrawOnParentResize: true,
              redrawOnWindowResize: false,
              type: "bar",
              toolbar: {
                show: false,
              },
              responsive: [
                {
                  breakpoint: 1216,
                  options: {
                    xaxis: { tickAmount: 4 },
                  },
                },
                {
                  breakpoint: 1024,
                  options: {
                    xaxis: { tickAmount: 2 },
                  },
                },
                {
                  breakpoint: 768,
                  options: {
                    chart: {
                      width: "100%",
                    },
                    xaxis: { tickAmount: 2 },
                  },
                },
              ],
              events: {
                click: (event, chartContext, w) =>
                  this.$emit("open-menu-inter", { ...w, type: 0 }),
              },
            },
            plotOptions: {
              bar: {
                distributed: true,
                horizontal: true,
                borderRadius: 4,
                colors: {
                  backgroundBarColors: ["#f9f8f8"],
                },
              },
            },
            states: {
              normal: {
                filter: {
                  type: "none", // No aplica ningún filtro cuando está en estado normal
                },
              },
              active: {
                allowMultipleDataPointsSelection: false,
                filter: {
                  type: "none", // No aplica ningún filtro cuando está en estado activo (seleccionado)
                },
              },
            },
            colors: [],
            dataLabels: {
              enabled: false,
            },
            tooltip: {
              enabled: true,
              custom: ({ series, seriesIndex, dataPointIndex, w }) =>
                this.tooltipBar({ series, seriesIndex, dataPointIndex, w }),
              shared: true,
              intersect: false,
              followCursor: true,
              items: {
                display: "flex",
              },
            },
            legend: {
              show: false,
            },
            xaxis: {
              min: 0,
              max: 100,
              // Menos marcas por defecto (0-20-40-60-80-100) y ocultar las que
              // se solapen; el nº de marcas se reduce aún más en pantallas
              // angostas vía chart.responsive.
              tickAmount: 5,
              labels: {
                rotate: 0,
                hideOverlappingLabels: true,
              },
            },
          },
          // Ancho responsivo: que la gráfica llene su columna y se reajuste al
          // redimensionar (antes era fijo "370" y se desbordaba/no llenaba).
          width: "100%",
          height: "185",
          type: "bar",
        };

        // Custom barHeight for group dimenc
        if (group === "dimenc") {
          graph.options.plotOptions.bar.barHeight = "20.5359";
        }

        graph.series[0].data = labels.map((x) => {
          const v = dataSummary.total[x].p;
          const vComp = dataSummary.processComp
            ? dataSummary.processComp.total[x].p
            : 0;
          const d = {
            x: this.namevars[x],
            key: x,
            y: v.toFixed(1),
            group,
          };

          if (dataSummary.processComp && vComp) {
            d.goals = [
              {
                name: "Anterior",
                value: vComp.toFixed(1),
                strokeWidth: 2,
                strokeDashArray: 2,
                strokeColor: "#000000",
              },
            ];
          }

          graph.options.colors.push(colors[this.rangos(v)]);
          return d;
        });
        return graph;
      }
    },
    tooltipBar({ series, seriesIndex, dataPointIndex, w }) {
      const data = {
        group: w.config.series[0].data[dataPointIndex].group,
        dim: w.config.series[0].data[dataPointIndex].key,
        dataValue: w.config.series[0].data[dataPointIndex].y.replace(".", ","),
        valueColor: w.config.colors[dataPointIndex],
        dataTarget: w.config.series[0].data[dataPointIndex].goals
          ? w.config.series[0].data[dataPointIndex].goals[0].value
          : 0,
        targetColor: w.config.series[0].data[dataPointIndex].goals
          ? w.config.series[0].data[dataPointIndex].goals[0].strokeColor
          : 0,
      };
      data.title = this.calificaciones[data.group]["dimensiones"][
        data.dim
      ].title;
      data.def = this.calificaciones[data.group]["dimensiones"][data.dim].def;
      const labelTarget = w.config.series[0].data[dataPointIndex].goals
        ? "<div style='display: flex;'>" +
          `<div style='width: 15px; border: 1px solid darkgray; height: 15px; background: ${data.targetColor}; margin-right: 5px'></div>` +
          "<strong class='has-text-white' style='margin-right: 5px'>Anterior</strong>" +
          data.dataTarget +
          "%" +
          "</div>"
        : "";

      return `<div>
        <strong style="color: white; font-size: 15px;">${data.title}</strong>
        <br>
        <div style='display: flex;'>
          <div style='width: 15px; border: 1px solid darkgray; height: 12px; background: ${data.valueColor}; margin-right: 5px'></div>
          <strong class='has-text-white' style='margin-right: 5px'>Actual</strong>
          ${data.dataValue}%
        </div>
        ${labelTarget}
        <br>
        <div>
            <strong style="color: white; font-size: 15px;">Definición</strong>
            <p>
                ${data.def}
            </p>
        </div>
        <br>
        <span class='is-size-7 has-text-weight-bold'>Clic para ver más.</span>
      </div>`;
    },
  },
};
</script>

<style lang="scss" scoped>
.clima-text-block {
  padding: 1.5rem;
  flex: 1;
}

.clima-nombre-line {
  font-size: 1.25rem;
  font-weight: 400;
  margin: 0 0 4px;
}

.clima-content-value {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.clima-valor-line {
  font-size: 1.9rem;
  font-weight: 700;
  margin: 0;
}

/* Engagement (result indicator) */

.header-right-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
}

.engagement-circle {
  /* Match the height of the "Toda la organización" box
     (h1 with is-size-3 font + 1.5rem padding ≈ 100px) */
  width: 110px;
  height: 110px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  text-align: center;
  position: relative;
  box-shadow: 0 2px 4px rgba(50, 50, 50, 0.4);
}

.engagement-circle .engagement-label {
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}

.engagement-circle .engagement-value-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  margin-top: 4px;
}

.engagement-circle .engagement-value {
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1;
}

/* directionIndicator renders an SVG with an inline `margin-right: 15px`
   that throws off centering inside the circle — neutralize it here. */
.engagement-circle .engagement-variation ::v-deep svg {
  margin-right: 0 !important;
  padding: 1px !important;
}

/* Tags */

.tagName {
  width: 110px;
}
.tagNumber {
  width: 70px;
}

.tagIcon {
  width: 25px;
  padding-left: 15px !important;
}

.cursor {
  cursor: pointer;
}

.bloquex1 {
  background-color: #ffffff;
  border-style: solid;
  border-width: 2px 1px 1px 2px;
  border-radius: 2px 0 0 0;
  border-color: #c2c2c2;
}

.bloquex2 {
  background-color: #ffffff;
  border-style: solid;
  border-width: 2px 2px 1px 1px;
  border-radius: 0 2px 0 0;
  border-color: #c2c2c2;
}

.bloquex3 {
  background-color: #ffffff;
  border-style: solid;
  border-width: 1px 1px 2px 2px;
  border-radius: 0 0 0 2px;
  border-color: #c2c2c2;
  padding-top: 2.5rem;
}

.bloquex4 {
  background-color: #ffffff;
  border-style: solid;
  border-width: 1px 2px 2px 1px;
  border-radius: 0 0 2px 0;
  border-color: #c2c2c2;
  padding-top: 2.5rem;
}

.bloquex5 {
  background-color: #ffffff;
  border-style: solid;
  border-width: 2px;
  border-radius: 2px;
  border-color: #c2c2c2;
  @media (min-width: 769px) {
    // Mismo ancho que las gráficas de los cuadrantes: cada una ocupa 1/3 del
    // contenedor (is-8 de is-6). Usamos % (relativo a #graphsContent, que es
    // position: relative) y NO vw, que incluía el sidebar y la hacía más ancha.
    width: clamp(220px, 33.333%, 438px) !important;
    height: 240px !important;
    z-index: 2 !important;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    position: absolute;
  }
  @media (max-width: 768px) {
    position: static !important;
    transform: none !important;
    width: 100% !important;
    height: auto !important;
    order: -1;
    margin-bottom: 0.5rem;
  }
}

.titleLeft {
  position: absolute;
  z-index: 2;
  top: 45.5%;
  background: white;
  margin-left: 40px;
  padding: 0 6px;
}

.titleRight {
  position: absolute;
  z-index: 2;
  top: 45.5%;
  background: white;
  left: 82%;
  padding: 0 6px;
}

.engagement-badge-mobile {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border-radius: 8px;
  min-width: 72px;
  cursor: pointer;
}

.engagement-badge-mobile .engagement-badge-label {
  font-size: 0.7rem;
  font-weight: 500;
  line-height: 1;
  background-color: rgba(0, 0, 0, 0.09);
  border-radius: 20px;
  padding: 2px 8px;
}

.engagement-badge-conntent-value {
  display: flex;
  align-items: center;
  gap: 10px;
}

.engagement-badge-mobile .engagement-badge-value {
  font-size: 1rem;
  font-weight: 700;
  margin-top: 2px;
}

@media (max-width: 768px) {
  .clima-main-flex {
    align-items: stretch !important;
    justify-content: space-between !important;
  }

  .clima-content-value {
    justify-content: flex-start;
  }

  .clima-text-block {
    text-align: left;
  }

  // Notificaciones: menos padding interno
  .bloquex1,
  .bloquex2,
  .bloquex3,
  .bloquex4 {
    padding: 1rem 0.75rem;
    // Elimina los bordes que forman la "matriz" — no tiene sentido en mobile
    border-width: 1px !important;
    border-radius: 6px !important;
  }

  .bloquex3,
  .bloquex4 {
    padding-top: 1rem;
  }

  // Dimensiones Centrales: sale del absolute y fluye normal
  .bloquex5 {
    position: static !important;
    transform: none !important;
    width: 100% !important;
    height: auto !important;
    order: -1;
    border: 0;
  }

  // Tags de nombre/número más compactos
  .tagName {
    width: 90px;
    font-size: 0.75rem;
  }

  .tagNumber {
    width: 55px;
    font-size: 0.75rem;
  }

  // Columnas internas de cada bloque (la gráfica ocupa todo)
  .bloquex1 .columns,
  .bloquex2 .columns,
  .bloquex3 .columns,
  .bloquex4 .columns {
    display: block;

    .column {
      padding: 0;
      width: 100% !important;
      max-width: 100% !important;
      flex: none !important;
    }
  }

  .main-result-row {
    flex-wrap: nowrap;
    align-items: stretch;
  }

  .main-result-row > .column:first-child {
    display: none;
  }

  .main-result-row > .column.is-8 {
    flex: 1 !important;
    width: auto !important;
    max-width: 100% !important;
    padding: 0 0.5rem;
  }

  .main-result-row > .column:last-child {
    flex: 0 0 auto !important;
    width: auto !important;
    padding: 0 0.5rem;
  }

  .header-right-actions {
    display: none;
  }

  // Engagement más pequeño
  .engagement-circle {
    width: 85px;
    height: 85px;
  }

  .engagement-circle .engagement-label {
    font-size: 0.75rem;
  }

  .engagement-circle .engagement-value {
    font-size: 0.8rem;
  }

  // Header con clima total: menos padding
  .has-text-centered.is-size-3 h1 {
    font-size: 1.1rem !important;
    padding: 0.75rem !important;
  }

  // Ocultar títulos posicionados (Foco Interno, Foco Externo, Flexibilidad, Consistencia)
  #graphsContent > .column.is-hidden-mobile {
    display: none !important;
  }
  #graphsContent {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  // Las columnas (is-6/is-12) conservan su width de Bulma (50%/…) dentro del
  // flex en columna, dejando espacio muerto a la derecha. En móvil cada
  // cuadrante debe ocupar todo el ancho.
  #graphsContent > .column {
    width: 100% !important;
    max-width: 100% !important;
    flex: none !important;
  }

  .clima-text-block {
    padding: 0.75rem;
  }

  .clima-nombre-line {
    font-size: 0.85rem;
    font-weight: 400;
  }

  .clima-valor-line {
    font-size: 1.4rem;
    font-weight: 700;
  }
}
</style>

<!-- Non-scoped: el tooltip de ApexChart y el de v-tooltip (clase darkTooltip)
     se montan fuera del árbol del componente, el estilo debe ser global. -->
<style>
.engagement-badge-conntent-value svg {
  margin-right: 0 !important;
}

.darkTooltip .tooltip-inner {
  background: rgba(0, 0, 0, 0.9);
}
.darkTooltip .tooltip-arrow {
  border-color: rgba(0, 0, 0, 0.9);
}

.apexcharts-tooltip {
  /* pointer-events: auto !important; */
  background: rgba(0, 0, 0, 0.9) !important;
  color: white !important;
  border-radius: 3px !important;
  padding: 10px !important;
  font-size: 12px !important;
  width: auto !important;
  min-width: 260px !important;
  max-width: 360px !important;
  height: auto !important;
  overflow-y: scroll !important;
  font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif !important;
  white-space: normal !important;
}
</style>



// WEBPACK FOOTER //
// src/components/climan/components/tabs/Prioritization.vue